import React, { useState } from 'react';
import { Box, Flex } from 'rebass';
import { object } from 'prop-types';
import { ButtonStyled } from '@nike/nike-design-system-components';

import { ContractGroupModal, DeleteContractGroupModal } from './modals';

import useModal from '../../hooks/useModal';

const ProductContractGroupsEditHeader = ({ productContractGroup }) => {
  const [isAddContractsModalOpen, openAddContractsModal, closeAddContractsModal] = useModal();
  const [isDeleteContractGroupModalOpen, openDeleteContractGroupModal, closeDeleteContractGroupModal] = useModal();
  const [totalContracts, setTotalContracts] = useState(0);

  const handleAllContractsCount = contracts => {
    setTotalContracts(contracts.length);
  };

  return (
    <Flex width='100%' justifyContent='space-between' alignItems='center' mt='5px'>
      <Box fontWeight='bold' fontSize='16px'>
        {productContractGroup?.name}
      </Box>
      <Flex>
        <ButtonStyled
          type='button'
          appearance='secondary'
          background='light'
          size='small'
          onClick={openAddContractsModal}
        >
          Add Contracts
        </ButtonStyled>
        <Box mx={2} />
        <ButtonStyled type='button' size='small' onClick={openDeleteContractGroupModal}>
          Delete
        </ButtonStyled>
      </Flex>

      <ContractGroupModal
        actionName={`Add ${totalContracts} Contracts`}
        closeModal={closeAddContractsModal}
        isOpen={isAddContractsModalOpen}
        productContractGroup={productContractGroup}
        title={`Add Contracts To ${productContractGroup?.name}`}
        type='add'
        handleAllContractsCount={handleAllContractsCount}
      />

      <DeleteContractGroupModal
        isOpen={isDeleteContractGroupModalOpen}
        closeModal={closeDeleteContractGroupModal}
        contractGroup={productContractGroup}
      />
    </Flex>
  );
};

ProductContractGroupsEditHeader.propTypes = {
  productContractGroup: object.isRequired
};

export default ProductContractGroupsEditHeader;
